import type { DemoSourceType } from '../types';
import type { YoutubeSourceValue } from './types';

export const previewYoutubeSources: DemoSourceType<YoutubeSourceValue> = {
  'youtube-touropia': {
    label: 'Youtube: @touropia',
    source: {
      platform: 'youtube',
      connectionType: 'youtubeChannel',
      id: 'kkpbfr1x',
      name: 'Youtube',
      source: 'https://www.youtube.com/user/touropia',
      youtubeChannel: {
        kind: 'youtube#channel',
        etag: 'FqPWf21lN4h0q5ZKHbeeXhStwkk',
        id: 'UCh3Rpsdv1fxefE0ZcKBaNcQ',
        snippet: {
          title: 'touropia',
          description:
            'Touropia features the most amazing sights around the world divided into various \u201cbest of\u201d lists. Topics can range from landscapes, ancient monuments, islands, wildlife, countries and anything else that we find interesting. We create these lists for entertainment purposes but also to provide a sense of what there is to see in a country, city or continent and hope they are useful as a starting point for your next great travel journey.',
          publishedAt: '2011-07-25T08:46:19Z',
          thumbnails: {
            default: {
              url: 'https://yt3.ggpht.com/ytc/AAUvwngPdPPmjR3-YpjhRPLTl4XOw0CkUlbAqXI0kKj1=s88-c-k-c0x00ffffff-no-rj',
              width: 88,
              height: 88
            },
            medium: {
              url: 'https://yt3.ggpht.com/ytc/AAUvwngPdPPmjR3-YpjhRPLTl4XOw0CkUlbAqXI0kKj1=s240-c-k-c0x00ffffff-no-rj',
              width: 240,
              height: 240
            },
            high: {
              url: 'https://yt3.ggpht.com/ytc/AAUvwngPdPPmjR3-YpjhRPLTl4XOw0CkUlbAqXI0kKj1=s800-c-k-c0x00ffffff-no-rj',
              width: 800,
              height: 800
            }
          },
          defaultLanguage: 'en',
          localized: {
            title: 'touropia',
            description:
              'Touropia features the most amazing sights around the world divided into various \u201cbest of\u201d lists. Topics can range from landscapes, ancient monuments, islands, wildlife, countries and anything else that we find interesting. We create these lists for entertainment purposes but also to provide a sense of what there is to see in a country, city or continent and hope they are useful as a starting point for your next great travel journey.'
          }
        },
        contentDetails: {
          relatedPlaylists: {
            likes: '',
            favorites: '',
            uploads: 'UUh3Rpsdv1fxefE0ZcKBaNcQ'
          }
        }
      },
      youtubeSource: 'UUh3Rpsdv1fxefE0ZcKBaNcQ'
    }
  },
  'youtube-mrBeast': {
    label: 'Youtube: @MrBeast',
    source: {
      platform: 'youtube',
      id: 'm2dd0syc',
      name: 'Youtube',
      connectionType: 'youtubeChannel',
      source: 'https://www.youtube.com/@MrBeast',
      youtubeChannel: {
        kind: 'youtube#channel',
        etag: 'KhGBzXPEr6TK36hStBBtXM-GOY0',
        id: 'UCX6OQ3DkcsbYNE6H8uQQuVA',
        snippet: {
          title: 'MrBeast',
          description:
            "SUBSCRIBE FOR A COOKIE!\n\nAccomplishments:\n- Raised $20,000,000 To Plant 20,000,000 Trees\n- Removed 30,000,000 pounds of trash from the ocean\n- Built wells in Africa\n- helped 1,000 blind people see\n- helped 1,000 deaf people hear\n- Given millions to charity\n- Started my own snack company Feastables\n- Donated over 100 cars lol\n- Gave away a private island (twice)\n- Gave away 1 million dollars in one video\n- Counted to 100k\n- Read the Dictionary\n- Read Bee Movie Script\n- Read Longest English Word\n- Watched Paint Dry\n- Ubering Across America\n- Watched It's Every Day Bro For 10 Hours\n- Ran a marathon in the world's largest shoes\n- Adopted every dog in a shelter\n- Bought $1,000,000 in lottery tickets\n- Sold houses for $1\n- I got buried alive\n- Recreated Squid Game in real life\n- Gave away a chocolate factory\n- Gave away private jet\n- Survived 50 hours in Antarctica\nYou get the point haha\n\n\n*Do not email me asking for money, I give away money because it makes me happy :)",
          customUrl: '@mrbeast',
          publishedAt: '2012-02-20T00:43:50Z',
          thumbnails: {
            default: {
              url: 'https://yt3.ggpht.com/fxGKYucJAVme-Yz4fsdCroCFCrANWqw0ql4GYuvx8Uq4l_euNJHgE-w9MTkLQA805vWCi-kE0g=s88-c-k-c0x00ffffff-no-rj',
              width: 88,
              height: 88
            },
            medium: {
              url: 'https://yt3.ggpht.com/fxGKYucJAVme-Yz4fsdCroCFCrANWqw0ql4GYuvx8Uq4l_euNJHgE-w9MTkLQA805vWCi-kE0g=s240-c-k-c0x00ffffff-no-rj',
              width: 240,
              height: 240
            },
            high: {
              url: 'https://yt3.ggpht.com/fxGKYucJAVme-Yz4fsdCroCFCrANWqw0ql4GYuvx8Uq4l_euNJHgE-w9MTkLQA805vWCi-kE0g=s800-c-k-c0x00ffffff-no-rj',
              width: 800,
              height: 800
            }
          },
          defaultLanguage: 'en',
          localized: {
            title: 'MrBeast',
            description:
              "SUBSCRIBE FOR A COOKIE!\n\nAccomplishments:\n- Raised $20,000,000 To Plant 20,000,000 Trees\n- Removed 30,000,000 pounds of trash from the ocean\n- Built wells in Africa\n- helped 1,000 blind people see\n- helped 1,000 deaf people hear\n- Given millions to charity\n- Started my own snack company Feastables\n- Donated over 100 cars lol\n- Gave away a private island (twice)\n- Gave away 1 million dollars in one video\n- Counted to 100k\n- Read the Dictionary\n- Read Bee Movie Script\n- Read Longest English Word\n- Watched Paint Dry\n- Ubering Across America\n- Watched It's Every Day Bro For 10 Hours\n- Ran a marathon in the world's largest shoes\n- Adopted every dog in a shelter\n- Bought $1,000,000 in lottery tickets\n- Sold houses for $1\n- I got buried alive\n- Recreated Squid Game in real life\n- Gave away a chocolate factory\n- Gave away private jet\n- Survived 50 hours in Antarctica\nYou get the point haha\n\n\n*Do not email me asking for money, I give away money because it makes me happy :)"
          },
          country: 'US'
        },
        contentDetails: {
          relatedPlaylists: {
            likes: '',
            favorites: '',
            uploads: 'UUX6OQ3DkcsbYNE6H8uQQuVA'
          }
        }
      },
      youtubeSource: 'UUX6OQ3DkcsbYNE6H8uQQuVA'
    }
  },
  'youtube-wwe': {
    label: 'Youtube: WWE',
    source: {
      platform: 'youtube',
      id: 'm2dd1tyc',
      name: 'Youtube',
      connectionType: 'youtubePlaylist',
      source:
        'https://www.youtube.com/playlist?list=PLqIVmFaHA8Bq1Gbge8s0l6IDqubIkxGig',
      youtubeChannel: {
        kind: 'youtube#channel',
        etag: 'UWShQ7IoV3dTtqmWczLnIsgF5FM',
        id: 'UCJ5v_MCY6GNUBTO8-D3XoAg',
        snippet: {
          title: 'WWE',
          description:
            'WWE on YouTube is your number one spot to catch WWE original shows and exclusives!\n\nWatch videos from all of your favorite WWE Superstars, backstage fallout from live shows including Raw, SmackDown, NXT and original shows such as Top 10, WWE Playlist, Superstar Playback and much more! \n\nSubscribe - https://goo.gl/2YO0Is\n\nStream WWE on Peacock https://pck.tv/2PIAQJI in the U.S. and on WWE Network http://wwe.yt/wwenetwork everywhere else.\n',
          customUrl: '@wwe',
          publishedAt: '2007-05-11T01:20:02Z',
          thumbnails: {
            default: {
              url: 'https://yt3.ggpht.com/ytc/AIdro_kRzpOO6EOnWYXSBHEhJft2_uVXk2uIjCWVJSAlAOCUOdgc=s88-c-k-c0x00ffffff-no-rj',
              width: 88,
              height: 88
            },
            medium: {
              url: 'https://yt3.ggpht.com/ytc/AIdro_kRzpOO6EOnWYXSBHEhJft2_uVXk2uIjCWVJSAlAOCUOdgc=s240-c-k-c0x00ffffff-no-rj',
              width: 240,
              height: 240
            },
            high: {
              url: 'https://yt3.ggpht.com/ytc/AIdro_kRzpOO6EOnWYXSBHEhJft2_uVXk2uIjCWVJSAlAOCUOdgc=s800-c-k-c0x00ffffff-no-rj',
              width: 800,
              height: 800
            }
          },
          defaultLanguage: 'en',
          localized: {
            title: 'WWE',
            description:
              'WWE on YouTube is your number one spot to catch WWE original shows and exclusives!\n\nWatch videos from all of your favorite WWE Superstars, backstage fallout from live shows including Raw, SmackDown, NXT and original shows such as Top 10, WWE Playlist, Superstar Playback and much more! \n\nSubscribe - https://goo.gl/2YO0Is\n\nStream WWE on Peacock https://pck.tv/2PIAQJI in the U.S. and on WWE Network http://wwe.yt/wwenetwork everywhere else.\n'
          }
        },
        contentDetails: {
          relatedPlaylists: {
            likes: '',
            uploads: 'UUJ5v_MCY6GNUBTO8-D3XoAg'
          }
        }
      },
      youtubeSource: 'PLqIVmFaHA8Bq1Gbge8s0l6IDqubIkxGig'
    }
  }
};
